(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/tipsinfo/assets/javascripts/tipsinfo-table-components/tipsinfo-table.body.js') >= 0) return;  svs.modules.push('/components/tipsen/tipsinfo/assets/javascripts/tipsinfo-table-components/tipsinfo-table.body.js');
"use strict";

const clx = svs.components.lbUtils.clx;
const TableRow = svs.components.tipsen.tipsinfo.tableComponents.TableRow;
const TableBody = _ref => {
  let children = _ref.children,
    className = _ref.className;
  return React.createElement("tbody", {
    className: clx('tipsinfo_table-body', className)
  }, children);
};
TableBody.Row = TableRow;
setGlobal('svs.components.tipsen.tipsinfo.tableComponents.TableBody', TableBody);

 })(window);